import { useQuery } from '@tanstack/react-query';
import { queryKeys } from 'utils/queryKeys';
import { api } from 'api';

export const useShareLinksQuota = () => {
  const { data, isLoading } = useQuery({
    queryFn: async () => {
      const { data } = await api.getInvitesQuota();

      return data;
    },
    queryKey: queryKeys.shareLinksQuota(),
  });

  return {
    quota: data,
    isLoading,
  };
};
